import React from 'react';
import PropTypes from 'prop-types';

import { Strings } from 'HELPERS';
import { tConsume } from 'TRANSLATION';
import defaults from 'DEFAULTS';
import termsFile from '@assets/documents/Platform Terms of Use FIN.CLUB.pdf';

function ConditionsBlock({ t }) {
  const str = t('component.conditions.tpl');
  const { terms_and_conditions, privacy_policy, home } = defaults.website;

  if (!terms_and_conditions || !privacy_policy) {
    return null;
  }

  const replace = [
    <a key={0} href={termsFile} target={'_blank'}>
      Terms & Conditions
    </a>,
    // <a key={1} href={privacy_policy} target={'_blank'}>
    //   {t('component.conditions.conditions1')}
    // </a>,
    // <a key={2} href={home.protocol && home.host ? `${home.protocol}://${home.host}` : '/'} target={'_blank'}>
    //   Fin.Club
    // </a>,
  ];

  return (
    <div className={'conditions-block'}>
      <p>
        <Strings.CompileComponent str={str} replace={replace} />
      </p>
    </div>
  );
}

export default tConsume(ConditionsBlock);

ConditionsBlock.propTypes = {
  t: PropTypes.func.isRequired,
};
